import React, { useState, useEffect } from "react";
import {
  shouldShowInstallTopBanner,
  getCurrentInstallLink,
} from "@/utils/countryConfigUtils";
import styles from "./InstallTopBanner.module.less";
import useScreenDesign from "@/Core/utils/hooks/useScreenDesign";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import bgImage from "./assets/bg.webp";
import { openInstallLinkWithApkTransfer } from "@/features/install/apkTransfer";
import { INSTALL_TRACK_SOURCES } from "@/features/analytics/em/events";
import {
  trackInstallEntryClose,
  useTrackInstallEntryView,
} from "@/features/install/installEntryAnalytics";

const InstallTopBanner: React.FC = () => {
  const isMobile = useScreenDesign();
  const { t } = useTranslationPlus("install");
  const [isVisible, setIsVisible] = useState(true);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const shouldShow =
    isMobile && shouldShowInstallTopBanner() && isVisible;

  useTrackInstallEntryView({
    visible: shouldShow,
    source: INSTALL_TRACK_SOURCES.INSTALL_TOP_BANNER,
    closable: true,
  });

  // 5秒后显示关闭按钮
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCloseButton(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  // 判断是否显示 Banner（从配置中读取）
  if (!shouldShow) {
    return null;
  }

  const handleDownloadClick = () => {
    const installLink = getCurrentInstallLink();
    if (installLink) {
      void openInstallLinkWithApkTransfer(installLink, {
        source: INSTALL_TRACK_SOURCES.INSTALL_TOP_BANNER,
      });
    }
  };

  const handleCloseClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    trackInstallEntryClose(INSTALL_TRACK_SOURCES.INSTALL_TOP_BANNER);
    setIsVisible(false);
  };

  return (
    <div
      className={styles.bannerContainer}
      style={{ backgroundImage: `url(${bgImage})` }}
      onClick={handleDownloadClick}
    >
      <div className={styles.content}>
        <button className={styles.installButton}>{t("banner.install")}</button>

        <div className={styles.slogan}>{t("banner.slogan")}</div>

        {showCloseButton && (
          <div className={styles.closeIconContainer} onClick={handleCloseClick}>
            <svg
              className={styles.closeIcon}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 6L18 18M18 6L6 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstallTopBanner;
